import script from "./MainTableRow.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainTableRow.vue?vue&type=script&lang=ts&setup=true"

import "./MainTableRow.vue?vue&type=style&index=0&id=7f80a38b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f80a38b"]])

export default __exports__